/* Imports */
import { API_HELPER } from "@/helpers/api.js";

/* Exports */
// API services that can be invoked on the modules
export const FAQS_SERVICE = {postFaq, getFaqs, putFaq, deleteFaqById, getFaqById};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Faqs";

/* Services */
//Service to create Faqs
function postFaq(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'POST',
        headers: { "Content-Type":"application/json" },
        body: JSON.stringify(input)
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to get paginated faqs
function getFaqs(queryParams)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'GET'
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}


//Service to update faqs
function putFaq(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'PUT',
        headers: { "Content-Type":"application/json" },
        body: JSON.stringify(input)
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to remove faqs
function deleteFaqById(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id]);

    const requestOptions = {
        method: 'DELETE'
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to get faq details
function getFaqById(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id]);

    const requestOptions = {
        method: 'GET'
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

